import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store';
import ElementUI from 'element-ui';
import ECharts from 'vue-echarts'
import axios from 'axios'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/funnel'

import 'element-ui/lib/theme-chalk/index.css';
//import './assets/font/iconfont.css'
import './assets/icon/iconfont.css'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueQuillEditor from 'vue-quill-editor'
import * as Quill from 'quill' //引入编辑器
import resizeImage from 'quill-image-resize-module' // 图片缩放组件。
import { ImageDrop } from 'quill-image-drop-module'; // 图片拖动组件。
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/resizeImage ', resizeImage )
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

import vueSwiper from 'vue-awesome-swiper'
// import style
import 'swiper/css/swiper.css'

Vue.use(vueSwiper);
Vue.use(ElementUI, axios);
Vue.component('v-chart', ECharts)

import Print from 'vue-print-nb'
Vue.use(Print)

import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import 'font-awesome/css/font-awesome.min.css';
import "dhtmlx-gantt/codebase/skins/dhtmlxgantt_material.css";
import '@wangeditor/editor/dist/css/style.css';
// 【P92】全站单据列表统一样式（8 类共用；销售/财务/市场三端一致）
import './assets/css/bill-list.css';

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'fArZXtiwz630AUsKaUYeH94fbwMdEWfy'
})

/*
import VueBMap from 'vue-bmap-gl'
import 'vue-bmap-gl/dist/style.css'
VueBMap.initBMapApiLoader({
  ak: 'fArZXtiwz630AUsKaUYeH94fbwMdEWfy'
})
Vue.use(VueBMap)
*/

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

/* 统一品牌设计令牌（opt-in 工具类，不影响房态模块） */
import './styles/theme.css';

/* 统一列表样式：全站列表（合同单据页 + client 主列表）共用 */
import './assets/css/unified-list.css';



// Application
var vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.vm = vm;



// new Vue({
//   el: '#app',
//   render: h => h(App),
//   router,
//   store,
// })



// WEBPACK FOOTER //
// ./src/main.js